document.addEventListener("DOMContentLoaded", function() {
  var container = document.getElementById("language-switcher-container");

  if (container) {
    var enButton = document.createElement("button");
    enButton.innerHTML = "EN";
    enButton.classList.add("lang-button");

    // 현재 언어가 EN일 경우, active 클래스 추가
    if (window.location.pathname.includes("/en")) {
      enButton.classList.add("active");
    }
    enButton.addEventListener("click", function() {
      window.location.href = "/en"; // EN 언어로 리다이렉션
    });

    var koButton = document.createElement("button");
    koButton.innerHTML = "KO";
    koButton.classList.add("lang-button");

    // 현재 언어가 KO일 경우, active 클래스 추가
    if (window.location.pathname.includes("/ko")) {
      koButton.classList.add("active");
    }
    koButton.addEventListener("click", function() {
      window.location.href = "/ko"; // KO 언어로 리다이렉션
    });

    container.appendChild(enButton);
    container.appendChild(koButton);
  }
});
